export const WINDOW_TYPES = {
    DESKTOP: 'Desktop',
    TABLET:  'Tablet',
    PHONE:   'Phone',
} as const;
